// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { oasys as _oasys } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the oasys chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 248
 * Chain Name: Oasys
 * Default Block Explorer: https://scan.oasys.games
 * Default RPC URL: https://rpc.mainnet.oasys.games
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { oasys } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: oasys,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const oasys = createCommon({
	..._oasys,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
